import { TProps } from './types/TProps';

const labelClassName = 'text-sm text-[var(--color-text)]';

const disabledLabelClassName = '!text-[var(--color-form-field-disabled-text)]';

export const FormFieldChoiceLabel = ({ disabled = false, className = '', children }: TProps) => (
  <span className={[disabled ? disabledLabelClassName : labelClassName, className].filter(Boolean).join(' ')}>
    {children}
  </span>
);
